import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useQuery } from "@tanstack/react-query";
import qs from "query-string";
import { Storage } from "@/shared/core-storages";

export const GET_STORAGES_FETCH_KEY = "GET_STORAGES_FETCH_KEY";

export const getStorage = async (
  zoneIds?: string | string[],
): Promise<Storage[]> => {
  const queryString = qs.stringify({ zoneIds });
  const response = await fetcher.get(`${API.GESLUB}/storage?${queryString}`);
  return response.data;
};

export const useGetStorage = (zoneIds?: string | string[]) => {
  const {
    data = [],
    error,
    isLoading,
    isFetching,
  } = useQuery<Storage[]>({
    queryKey: [GET_STORAGES_FETCH_KEY, zoneIds],
    queryFn: () => getStorage(zoneIds),
  });

  const isPending = isLoading || isFetching;

  return {
    data,
    error,
    isPending,
  };
};
